import { backgroundOrange, darkOrange } from '@/theme/colors'
import styled from 'styled-components'

export const Breadcrumb = styled.div`
    display: flex;
    align-items: center;
    gap: 0.375rem;
    flex-wrap: wrap;
    margin-bottom: 1.25rem;
    font-size: 0.8125rem;
    color: #4b5563;
`

export const BreadcrumbStep = styled.button<{ $current?: boolean }>`
    background: ${({ $current }) => ($current ? backgroundOrange : 'transparent')};
    border: 1px solid ${({ $current }) => ($current ? '#f0e0d6' : 'transparent')};
    border-radius: 6px;
    padding: 0.25rem 0.5rem;
    font-size: 0.8125rem;
    color: ${({ $current }) => ($current ? darkOrange : '#6b7280')};
    cursor: ${({ $current }) => ($current ? 'default' : 'pointer')};

    &:hover:not(:disabled) {
        text-decoration: ${({ $current }) => ($current ? 'none' : 'underline')};
    }
`

export const BreadcrumbSeparator = styled.span`
    color: #9ca3af;
`
